module.exports = __webpack_public_path__ + "static/media/btn5.9702a77f.svg";